import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import {
    provideTranslocoScope,
    TranslocoModule,
    TranslocoService,
} from '@jsverse/transloco';
import { firstValueFrom, forkJoin, Subscription, take } from 'rxjs';

@Component({
    selector: 'app-no-page-access',
    imports: [TranslocoModule, MatCardModule],
    templateUrl: './no-page-access.component.html',
    styleUrl: './no-page-access.component.scss',
    providers: [provideTranslocoScope('p_pad')],
})
export class NoPageAccessComponent implements OnInit, OnDestroy {
    translocoSub: Subscription;

    constructor(private translocoService: TranslocoService) {}

    async ngOnInit() {
        await firstValueFrom(
            forkJoin([
                this.translocoService.selectTranslation('p_pad').pipe(take(1)),
            ])
        );
        this.translocoSub = this.translocoService
            .selectTranslation('p_pad')
            .subscribe();
    }

    ngOnDestroy(): void {
        if (this.translocoSub) {
            this.translocoSub.unsubscribe();
        }
    }
}
